import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Group, LoadingOverlay } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { MainLayout } from '../../layouts'
import { ContentBox, BackListButton, SaveButton, ResetButton } from '../../partials'
import { FormTypes } from '../../../types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { IEmployeeParams } from '../../../store/types'
import { IFormRef } from '../../../types'
import { getFormattedValidationErrors } from '../../../utils/mixins'
import Form from './Form'
import { fetchCreateEmployee, resetCreateEmployee } from '../../../store/features/employees/createEmployeeSlice'
import {fetchListUsers} from "../../../store/features/users/listUsersSlice";

const Create = () => {
  const { t } = useTranslation()
  const formRef = useRef<IFormRef>(null)
  const dispatch = useAppDispatch()

  const { isLoading, response, error } = useAppSelector(state => state.createEmployee)

  useEffect(() => {
    if (response !== null) {
      showNotification({
        color: 'green',
        title: t('successful'),
        message: t('created')
      })

      dispatch(resetCreateEmployee())
    }
  }, [response, t, dispatch])

  useEffect(() => {
    dispatch(fetchListUsers({query: { per: 100000 }}))
  }, [dispatch])

  useEffect(() => {
    if (error !== null) {
      if (error.response.status === 422) {
        formRef.current!.setErrors(getFormattedValidationErrors(error))
      } else {
        showNotification({
          color: 'red',
          title: t('unsuccessful'),
          message: error.response.data ? error.response.data.message : t('errors.unknown')
        })
      }
    }
  }, [error, t])

  useEffect(() => {
    if (response !== null) {
      dispatch(resetCreateEmployee())
      formRef.current!.reset()
    }
  }, [response, dispatch])

  const handleSubmit = async (data: IEmployeeParams) => {
    await dispatch(fetchCreateEmployee(data))
  }

  return (
    <MainLayout>
      <LoadingOverlay visible={isLoading} />
      <ContentBox title={t('content_actions.create')}>
        <Form
          id="create-employee-form"
          type={FormTypes.CREATE}
          ref={formRef}
          initialValues={{
            company: '',
            user: '',
            is_admin: false
          }}
          onSubmit={handleSubmit}
        />
      </ContentBox>
      <ContentBox>
        <Grid>
          <Grid.Col span={6}>
            <BackListButton to="/employees" />
          </Grid.Col>
          <Grid.Col span={6}>
            <Group position="right">
              <SaveButton form="create-employee-form" />
              <ResetButton form="create-employee-form" />
            </Group>
          </Grid.Col>
        </Grid>
      </ContentBox>
    </MainLayout>
  )
}

export default Create
